<template>
  <DBox
    :id="'cmp-royalty-contracts-sidewindow-royalty_scale'"
    :addButton="false"
    :addLink="false"
    @add_click="onAddScaleTypes"
    :leftMenu="addLeftMenu"
    @menuClick="onMenuClicked"
  >
    <NTable
      class="dbox1"
      id="royalty-contracts-sidewindow-royalty_scale-list"
      :config="tableConfig"
      :headers="headers"
      :items="selectedContractDetails.scales || []"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('scales')">
            <div v-if="item['turnover_scale'] == 1">
              <TextField2
                disabled="disabled"
                :id="'scale_name'"
                :showLabel="false"
                :value="item['scale_name']"
                @blur="e => onTextFieldValueChange(e, item)"
                :bb="'none'"
              />
            </div>
            <div v-if="item['turnover_scale'] == 0">
              <TextField2
                :id="'scale_name'"
                :showLabel="false"
                :value="item['scale_name']"
                @blur="e => onTextFieldValueChange(e, item)"
                :bb="'none'"
              />
            </div>
          </td>
          <td v-bind="tdcon('catalogs')">
            <span class="txtov" :title="item['catalogs']">
              {{ item["catalogs"] }}
            </span>
          </td>
          <td v-bind="tdcon('edit')">
            <img
              src="static/icons/edit-blue.svg"
              @click.stop="e => onEditQuantityScales(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
          <td v-bind="tdcon('options')">
            <img
              src="static/icons/delete.svg"
              @click.stop="e => onDeleteScales(item)"
              class="dt-icon v5 s1 ut-center"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader
} from "../../../../plugins/datatable";
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import { ContractsService } from "../../services/contracts.service";
import { openModalRoute } from "../../../../dt-plugins/modal/modal.mixin";

export default {
  components: {
    DBox,
    NTable
  },
  props: ["selectedContractDetails"],
  computed: {
    tableConfig: function() {
      return createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      });
    },
    headers: function() {
      return [
        createTableHeader("scales"),
        createTableHeader("catalogs", { text: false }),
        createTableHeader("edit", { text: false, mw: 30 }),
        createTableHeader("options", { text: false, mw: 30 })
      ];
    },
    contract_id: function() {
      return this.$route.params.contract_id;
    },
    addLeftMenu() {
      if (this.selectedContractDetails.turnover_scale != null) {
        return [
          {
            text: this.$t("scale_by_quantity"),
            value: "scale_by_quantity"
          }
        ];
      } else {
        return [
          {
            text: this.$t("scale_by_quantity"),
            value: "scale_by_quantity"
          },
          {
            text: this.$t("scale_by_turnover"),
            value: "scale_by_turnover"
          }
        ];
      }
    }
  },
  methods: {
    onTextFieldValueChange: function({ name, value }, item) {
      this.$emit("changed", { name, value, item });
    },

    onAddScaleTypes: async function() {
      this.$emit("added", true);
    },

    onEditQuantityScales: function(selectedItem) {
      if (selectedItem.turnover_scale == 0) {
        this.$emit("edited_qty", selectedItem);
      } else if (selectedItem.turnover_scale == 1) {
        this.$emit("edited_turnover", selectedItem);
      }
    },

    onDeleteScales: async function(item) {
      const confirmationResult = await confirmDelete("name", item.scale_name);
      if (confirmationResult === "OK") {
        this.$emit("deleted", item);
      }
    },
    onMenuClicked(value) {
      if (value == "scale_by_quantity") {
        openModalRoute(this, "scale_quantity_form", {
          mode: "add"
        });
      } else if (value == "scale_by_turnover") {
        openModalRoute(this, "scale_turnover_form", {
          mode: "add"
        });
      }
    }
  }
};
</script>
